import React from "react";
import axios from "axios";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faSearch,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../masters/master.css";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";

import * as Yup from "yup";

const prospectFilterForm = Yup.object().shape({
  assetType: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  //brandCategory: Yup.string().required("Required"),
  assetName: Yup.string().required("Required"),
  //floor: Yup.string().required("Required"),
  //rangeFrom: Yup.string().required("Required"),
  //rangeTo: Yup.string().required("Required"),
});

const prospectValidation = Yup.object().shape({
  brand_name: Yup.string().required("Required"),
  fitout_period: Yup.string().required("Required"),
  notice_period: Yup.string().required("Required"),
  lease_period: Yup.string().required("Required"),
  lockin_period: Yup.string().required("Required"),
  renewal_term: Yup.string().required("Required"),
  min_guarantee: Yup.string().required("Required"),
  revenue_share: Yup.string().required("Required"),
  rent_deposit: Yup.string().required("Required"),
  cam_deposit: Yup.string().required("Required"),
  cam_rate: Yup.string().required("Required"),
  marketing_fund: Yup.string().required("Required"),
  property_tax: Yup.string().required("Required"),
  parking: Yup.string().required("Required"),
  signage: Yup.string().required("Required"),
  stamp_duty_by: Yup.string().required("Required"),
  exclusivity: Yup.string().required("Required"),
  remarks: Yup.string().required("Required"),
});

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class Prospect extends React.Component {
  state = {
    redirect: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: '',
    brandCategories: [],
    brandCategoryName: "",
    brandCategory: "",
    assetTypeList: [],
    brandCategoryList: [],
    cityList: [],
    assetList: [],
    floorList: [],
    comparativeData: [],
    initialValues: {
      assetType: "",
      city: "",
      brandCategory: "",
      assetName: "",
      floor: "",
      grossLeaseAreaFrom: "",
      grossLeaseAreaTo: "",
      rangeFrom: "",
      rangeTo: "",
      areaType: "",
      areaTypeValue: ""
    },
    prospectInitialValues: {
      brand_name: "",
      fitout_period: "",
      lease_period: "",
      lockin_period: "",
      min_guarantee: "",
      revenue_share: "",
      rent_deposit: "",
      cam_deposit: "",
      cam_rate: "",
      marketing_fund: "",
      property_tax: "",
      parking: "",
      signage: "",
      stamp_duty_by: "",
      exclusivity: "",
      remarks: "",
      notice_period: "",
      renewal_term: "",
    },
  };

  constructor(props) {
    super(props);
  }
  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/prospect/fetch-asset-type`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetTypeList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    fetch(`${apiUrl.apiUrl.url}/prospect/fetch-cities`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          cityList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    fetch(`${apiUrl.apiUrl.url}/prospect/fetch-brand-category`,{headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandCategoryList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  changeCity = (newValue) => {
    this.state.initialValues.city = newValue.value;
    this.state.initialValues.city = newValue.label;
    this.setState({});
    this.fetchAsset();
  };
  changeAssetType = (newValue) => {
    this.state.initialValues.assetType = newValue.value;
    this.state.initialValues.assetType = newValue.label;
    this.setState({});
    this.fetchAsset();
  };
  changeBrandCategory = (newValue) => {
    this.state.initialValues.brandCategory = newValue.value;
    this.state.initialValues.brandCategory = newValue.label;
    this.setState({});
  };
  changeAsset = (newValue) => {
    this.state.initialValues.assetName = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    this.fetchFloor();
  };
  changeAreaType = (newValue) => {
    this.state.initialValues.areaTypeValue = newValue.value;

    this.state.initialValues.areaType = newValue.label;
    this.setState({});
    //this.fetchFloor();
  };
  changeFloor = (newValue) => {
    console.log("cahnge floor");
    this.state.initialValues.floor = newValue.value;
    this.state.initialValues.floor = newValue.label;
    this.setState({});

    console.log(this.state.initialValues, "this.state.initialValues");
  };

  fetchAsset = () => {
    fetch(
      `${apiUrl.apiUrl.url}/prospect/fetch-asset?asset_type=${this.state.initialValues.assetType}&search_term=&city=${this.state.initialValues.city}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchFloor = () => {
    fetch(
      `${apiUrl.apiUrl.url}/prospect/fetch-floor?asset=${this.state.initialValues.assetName}`,
      {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          floorList: data.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false, });
  };

  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: '',
    });
  };

  render() {
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div >
    );
  }

  renderForm() {
    return (
      <div>
        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={prospectFilterForm}
          onReset={(values, actions) => {
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            var self = this;
            this.state.initialValues.grossLeaseAreaFrom = values.rangeFrom;
            this.state.initialValues.grossLeaseAreaTo = values.rangeTo;
            this.setState({});
            var prm = Object.entries(this.state.initialValues)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/prospect/fetch-leases?${prm}`,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                // alert("Something went wrong");
                this.setState({
                  popupalertMessage: true,
                  popupMessageContent: 'Something went wrong',
                });
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                self.setState({ redirect: true });
                if (typeof response.data.data != "undefined") {
                  self.state.comparativeData = response.data.data;
                } else {
                  // alert("No Comparatives found for these criteria.");
                  this.setState({
                    popupalertMessage: true,
                    popupMessageContent: 'No Comparatives found for these criteria.',
                  });
                  self.state.comparativeData = [];
                }

                self.setState({});
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Asset Type <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              isSearchable="true"
                              name="assetType"
                              value={{
                                label: this.state.initialValues.assetType,
                                value: this.state.initialValues.assetType,
                              }}
                              onChange={(e) => {
                                this.changeAssetType(e);
                              }}
                              options={this.state.assetTypeList.map((item) => ({
                                label: item,
                                value: item,
                              }))}
                            />
                            <ErrorMessage
                              name="assetType"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Brand Category <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              isSearchable="true"
                              name="brandCategory"
                              value={{
                                label: this.state.initialValues.brandCategory,
                                value: this.state.initialValues.brandCategory,
                              }}
                              onChange={(e) => {
                                this.changeBrandCategory(e, values);
                              }}
                              options={this.state.brandCategoryList.map(
                                (item) => ({
                                  label: item,
                                  value: item,
                                })
                              )}
                            />
                            <ErrorMessage
                              name="brandCategory"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            City <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              isSearchable="true"
                              name="city"
                              value={{
                                label: this.state.initialValues.city,
                                value: this.state.initialValues.city,
                              }}
                              onChange={(e) => {
                                this.changeCity(e, values);
                              }}
                              options={this.state.cityList.map((item) => ({
                                label: item,
                                value: item,
                              }))}
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div class="inputContainer col-lg-12 col-md-12">
                        <div class="row mb-3">
                          <label class="col-sm-4 col-form-label">
                            Gross Leasable Area Range (Sq.Ft)
                            <span class="astrik">*</span>
                          </label>
                          <div class="col-sm-3 dueDateFieldWidth">
                            <Field
                              name="rangeFrom"
                              type="text"
                              placeholder="From"
                              class="centerPlaceHolder"
                              onChange={(e) => {
                                //this.changeGroup(e);
                                handleChange(e);
                              }}
                            />
                            <ErrorMessage
                              name="rangeFrom"
                              component="div"
                              className="text-red"
                            />
                          </div>
                          <div class="col-sm-3 dueDateFieldWidth">
                            <Field
                              name="rangeTo"
                              type="text"
                              placeholder="To"
                              class="centerPlaceHolder"
                            />
                            <ErrorMessage
                              name="rangeTo"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Asset Name <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              isSearchable="true"
                              name="assetName"
                              value={{
                                label: this.state.initialValues.assetName,
                                value: this.state.initialValues.assetName,
                              }}
                              onChange={(e) => {
                                this.changeAsset(e, values);
                              }}
                              options={this.state.assetList.map((item) => ({
                                label: item.complex,
                                value: item.complex,
                              }))}
                            />
                            <ErrorMessage
                              name="assetName"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Area Type <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              isSearchable="true"
                              name="areaType"
                              value={{
                                label: this.state.initialValues.areaType,
                                value: this.state.initialValues.areaTypeValue,
                              }}
                              onChange={(e) => {
                                this.changeAreaType(e, values);
                              }}
                              options={[{ 'key': 'Carpet', 'value': 'carpet' }, { 'key': 'chargeable', 'value': 'Gross Leasable Area' }].map(
                                (item) => ({
                                  label: item.value,
                                  value: item.key
                                })
                              )}
                            />
                            <ErrorMessage
                              name="areaType"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Floor <span className="astrik">*</span>
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              isSearchable="true"
                              name="floor"
                              value={{
                                label: this.state.initialValues.floor,
                                value: this.state.initialValues.floor,
                              }}
                              onChange={(e) => {
                                this.changeFloor(e);
                              }}
                              options={this.state.floorList.map((item) => ({
                                label: item,
                                value: item,
                              }))}
                            />
                            <ErrorMessage
                              name="floor"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer">
                        <div>
                          <button type="submit">
                            <FontAwesomeIcon icon={faSearch} /> Search
                          </button>
                          <button type="reset">
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <Formik
          initialValues={this.state.prospectInitialValues}
          enableReinitialize
          validationSchema={prospectValidation}
          onReset={(values, actions) => {
            for (const [key, value] of Object.entries(
              this.state.prospectInitialValues
            )) {
              this.state.prospectInitialValues[key] = "";
            }
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            var self = this;
            values.asset_type = this.state.initialValues.assetType;
            values.city = this.state.initialValues.city;
            values.brand_category = this.state.initialValues.brandCategory;
            values.asset_name = this.state.initialValues.assetName;
            values.floor = this.state.initialValues.floor;
            values.gla_from = this.state.initialValues.grossLeaseAreaFrom;
            values.gla_to = this.state.initialValues.grossLeaseAreaTo;
            values.comparativeData = this.state.comparativeData;
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/prospect/save`,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                // alert("Something went wrong");
                this.setState({
                  popupalertMessage: true,
                  popupMessageContent: 'Something went wrong',
                });
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                for (const [key, value] of Object.entries(
                  self.state.prospectInitialValues
                )) {
                  self.state.prospectInitialValues[key] = "";
                  self.setState({});
                }
                for (const [key, value] of Object.entries(
                  self.state.initialValues
                )) {
                  self.state.initialValues[key] = "";
                  self.setState({});
                }
                //self.state.comparativeData = [];
                self.setState({});

                // self.setState({ redirect: true });
                // alert("Data Saved successfully.");
                self.setState({
                  messsagePopup: true,
                });

                self.props.history.push(
                  "/createlease/prospect/view/" + response.data.id
                );
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="container-fluid">
                  <div className="row">
                    <div className="tableContainer prospectTable">
                      <table className="table tableSimple">
                        <thead>
                          <tr>
                            <th scope="col">Field Name</th>
                            <th scope="col">Prospect</th>
                            {this.state.comparativeData.length >= 1 && (
                              <th scope="col">Comparative 001</th>
                            )}
                            {this.state.comparativeData.length >= 2 && (
                              <th scope="col">Comparative 002</th>
                            )}
                            {this.state.comparativeData.length >= 3 && (
                              <th scope="col">Comparative 003</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <h6>Brand Name</h6>
                            </td>
                            <td>
                              <Field
                                type="text"
                                name="brand_name"
                                className="tdInput"
                              ////value={this.state.prospectInitialValues.brand_name}
                              />
                              <ErrorMessage
                                name="brand_name"
                                component="div"
                                className="text-red"
                              />
                            </td>
                            {this.state.comparativeData.length >= 1 && (
                              <td scope="col">
                                {this.state.comparativeData[0]["Brand Name"]}
                              </td>
                            )}
                            {this.state.comparativeData.length >= 2 && (
                              <td scope="col">
                                {this.state.comparativeData[1]["Brand Name"]}
                              </td>
                            )}
                            {this.state.comparativeData.length >= 3 && (
                              <td scope="col">
                                {this.state.comparativeData[2]["Brand Name"]}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>LEASE TERMS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Lease Term</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Fitout Period (Days)</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="fitout_period"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.fitout_period}
                                      />
                                      <ErrorMessage
                                        name="fitout_period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Fitout Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Fitout Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Fitout Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Lease Period</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="lease_period"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.lease_period}
                                      />
                                      <ErrorMessage
                                        name="lease_period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Lease Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Lease Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Lease Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Lock In Period</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="lockin_period"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.lockin_period}
                                      />
                                      <ErrorMessage
                                        name="lockin_period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Lockin Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Lockin Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Lockin Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Notice Period</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="notice_period"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.notice_period}
                                      />
                                      <ErrorMessage
                                        name="notice_period"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Notice Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Notice Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Notice Period"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Renewal Terms</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="renewal_term"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.renewal_term}
                                      />
                                      <ErrorMessage
                                        name="renewal_term"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Renewal Date"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Renewal Date"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Renewal Date"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>COMMERCIALS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Commercials</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Minimum Guarantee</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="min_guarantee"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.min_guarantee}
                                      />
                                      <ErrorMessage
                                        name="min_guarantee"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Mininum Guarantee"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Mininum Guarantee"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Mininum Guarantee"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Revenue Share (%)</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="revenue_share"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.revenue_share}
                                      />
                                      <ErrorMessage
                                        name="revenue_share"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Revenue Share"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Revenue Share"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Revenue Share"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>SECURITY DEPOSITS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Security Deposits</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Rent Deposits (Months)</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="rent_deposit"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.rent_deposit}
                                      />
                                      <ErrorMessage
                                        name="rent_deposit"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Rent Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Rent Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Rent Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>CAM Deposits (Months)</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="cam_deposit"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.cam_deposit}
                                      />
                                      <ErrorMessage
                                        name="cam_deposit"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>OTHER TERMS</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Other Terms</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>CAM Rate</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="cam_rate"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.cam_rate}
                                      />
                                      <ErrorMessage
                                        name="cam_rate"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "CAM Rate"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "CAM Rate"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "CAM Rate"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Marketing Fund</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="marketing_fund"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.marketing_fund}
                                      />
                                      <ErrorMessage
                                        name="marketing_fund"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Marketing Fund"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Marketing Fund"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Marketing Fund"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Property Taxes</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="property_tax"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.property_tax}
                                      />
                                      <ErrorMessage
                                        name="property_tax"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Property Taxes"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Property Taxes"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Property Taxes"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Parking</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="parking"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.parking}
                                      />
                                      <ErrorMessage
                                        name="parking"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Car Parks"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Car Parks"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Car Parks"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Signage</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="signage"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.signage}
                                      />
                                      <ErrorMessage
                                        name="signage"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Signage Rights"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Signage Rights"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Signage Rights"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12">
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>OTHER CLAUSES</Accordion.Header>
                          <Accordion.Body>
                            <div className="tableContainer prospectTable mt-0">
                              <table className="table tableSimple">
                                <thead>
                                  <tr>
                                    <th scope="col">Other Clauses</th>
                                    <th scope="col">Prospect</th>
                                    {this.state.comparativeData.length >= 1 && (
                                      <th scope="col">Comparative 001</th>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <th scope="col">Comparative 002</th>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <th scope="col">Comparative 003</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <h6>Stamp Duty By</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="stamp_duty_by"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.stamp_duty_by}
                                      />
                                      <ErrorMessage
                                        name="stamp_duty_by"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "Stamp Duty By"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "Stamp Duty By"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "Stamp Duty By"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Exclusivity</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="exclusivity"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.exclusivity}
                                      />
                                      <ErrorMessage
                                        name="exclusivity"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                  <tr>
                                    <td>
                                      <h6>Remarks</h6>
                                    </td>
                                    <td>
                                      <Field
                                        type="text"
                                        name="remarks"
                                        className="tdInput"
                                      //value={this.state.prospectInitialValues.remarks}
                                      />
                                      <ErrorMessage
                                        name="remarks"
                                        component="div"
                                        className="text-red"
                                      />
                                    </td>
                                    {this.state.comparativeData.length >= 1 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[0][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 2 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[1][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                    {this.state.comparativeData.length >= 3 && (
                                      <td scope="col">
                                        {
                                          this.state.comparativeData[2][
                                          "CAM Deposits"
                                          ]
                                        }
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="container mt-3">
                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer formSubmit">
                        <div>
                          <button type="submit">
                            Save Draft
                          </button>
                          <button type="reset">
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    );
  }
}

export default withRouter(Prospect); 
